export default __webpack_public_path__ + "../ckeditor/lang/de.js";